import { matchPath } from 'react-router-dom';

import { ROUTE_PATH } from 'constants/routes';

const PUBLIC_ROUTES = Object.values(ROUTE_PATH.PUBLIC);

const isPublicPath = (pathname: string) =>
  PUBLIC_ROUTES.some((route) => !!matchPath(route, pathname));

const getCurrentUrl = () => {
  const { pathname, search, hash } = window.location;
  if (isPublicPath(pathname)) {
    return undefined;
  }
  return `${pathname}${search}${hash}`;
};

export const returnUrlUtils = {
  getCurrentUrl,
};
